import type { IScore } from '../../models';

/** Возвращает строковое представление оценки с одним знаком дробной при наличии дробной части */
export const getScoreStringValue = (value: IScore['value']): string =>
    value % 2 === 0 ? value.toString() : value.toFixed(1).replace('.', ',');

/** Возвращает массив значений оценок */
export const getScoreValues = (scores: IScore[]): number[] => scores.map(score => score.value);

/** Возвращает строку для построения path по заданным значениям оценок */
export const createPentagramPath = (
    radius: number,
    angle: number,
    scoreValues: number[],
    minValue = 0
): string => {
    let path = '';

    scoreValues.forEach((value, index) => {
        const scaleFactor = (value + minValue) / (10 + minValue);
        const angleRad = index * angle - Math.PI / 2;
        const scaledRadius = radius * scaleFactor;
        const x = scaledRadius * Math.cos(angleRad);
        const y = scaledRadius * Math.sin(angleRad);
        if (index === 0) {
            path += `M ${x} ${y}`;
        } else {
            path += ` ${x} ${y}`;
        }
    });
    path += 'Z';

    return path;
};

/** Возвращает координату по оси X для вершин пентагона*/
export const getPentagramPointCoordinateX = (
    radius: number,
    pointIndex: number,
    angle: number
): number => radius * Math.cos(pointIndex * angle - Math.PI / 2);

/** Возвращает координату по оси Y для вершин пентагона*/
export const getPentagramPointCoordinateY = (
    radius: number,
    pointIndex: number,
    angle: number
): number => radius * Math.sin(pointIndex * angle - Math.PI / 2);
